export function InStockColumn(product) {
	if (product.combined_id?.startsWith('custom-')) return '';

	return product.in_stock === 'available' ? 'Yes' : 'No';
}
